import { useState } from "react";
import { faqs } from "@/mocks/melonData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-20">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-question-line" /> 常见问题
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">关于追更，你可能想问</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            把吃瓜、跟进与投稿的常见疑问一次说清。
          </p>
        </div>

        <div className="mt-9 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-100 px-5 py-4 text-sm leading-7 text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}